import { BaseResponse } from '../../../../../types/api/api.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { ForgotPasswordQueryParams } from './ForgotPasswordForm.types';

const PREFIX = '[forgotPasswordQuery]';

export const FORGOT_PASSWORD_QUERY_KEY = 'FORGOT_PASSWORD';

export const forgotPasswordQuery = async (params: ForgotPasswordQueryParams) => {
  console.log(PREFIX, `Requesting user account creation...`);

  console.log('params', params);

  const response = await AUTH_ENDPOINTS.forgotPassword(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as BaseResponse;
};
